import { createAction, props } from '@ngrx/store';

export const loadRoles = createAction('[Employee] Load Roles');
export const loadRolesSuccess = createAction('[Employee] LoadRoles Success', props<{ payload: any }>());
export const loadRolesFail = createAction('[Employee] Load Roles Fail', props<{ payload: any }>());

export const loadMoreRoles = createAction('[Employee] Load More Roles', props<{ payload: {skip: number, limit: number} }>());
export const loadMoreRolesSuccess = createAction('[Employee] Load More Roles Success', props<{ payload: any }>());
export const loadMoreRolesFail = createAction('[Employee] Load More Roles Fail', props<{ payload: any }>());

export const loadAllRoles = createAction('[Employee] Load All Roles');
export const loadAllRolesSuccess = createAction('[Employee]  Load All Roles Success', props<{ payload: any }>());
export const loadAllRolesFail = createAction('[Employee] Load All Roles Fail', props<{ payload: any }>());

export const searchRoles = createAction('[Employee] Search Roles', props<{ payload: any }>());
export const searchRolesSuccess = createAction('[Employee] Search Roles Success', props<{ payload: any }>());
export const searchRolesFail = createAction('[Employee] Search Roles Fail', props<{ payload: any }>());
